// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lMbUQm[data-testid\$='-content'] {
  width: 400px;
  padding: 0;
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-m);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.lMbUQm [data-testid\$='-header'] {
  min-height: 0;
  align-items: center;
}

.lMbUQm [data-testid\$='-title'] {
  font-size: 18px;
  font-weight: var(--font-weight-medium);
  line-height: 1;
  color: var(--text-neutral-dark);
}

.lMbUQm [data-testid\$='-close-button'] {
  width: 24px;
  height: 24px;
  margin-left: 0;
  flex-shrink: 0;
}

.lMbUQm .V4Eq6z {
  gap: var(--spacing-2);
  padding-top: var(--spacing-2);
}

.eMn17M {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
}

.HB8z1p {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
}

.yNxyJ9 dt,
.yNxyJ9 dd {
  display: inline;
  margin: 0;
}

.yNxyJ9 dt {
  font-weight: var(--font-weight-semibold);
}

.yNxyJ9 dd {
  font-weight: var(--font-weight-regular);
}

.Mpb37g {
  display: flex;
  gap: var(--spacing-2);
}

.oON4cX {
  z-index: 2100;
}

.Mpb37g .t7Z883 {
  flex: 1;
  min-height: 32px;
  padding-top: 0;
  padding-bottom: 0;
  border-width: 1px;
}

@media (max-width: 480px) {
  .Mpb37g {
    flex-direction: column-reverse;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/PatFacilitatorInfo/PatFacilitatorModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".modal[data-testid$='-content'] {\n  width: 400px;\n  padding: 0;\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-m);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.modal :global([data-testid$='-header']) {\n  min-height: 0;\n  align-items: center;\n}\n\n.modal :global([data-testid$='-title']) {\n  font-size: 18px;\n  font-weight: var(--font-weight-medium);\n  line-height: 1;\n  color: var(--text-neutral-dark);\n}\n\n.modal :global([data-testid$='-close-button']) {\n  width: 24px;\n  height: 24px;\n  margin-left: 0;\n  flex-shrink: 0;\n}\n\n.modal .modalBody {\n  gap: var(--spacing-2);\n  padding-top: var(--spacing-2);\n}\n\n.description {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n}\n\n.fields {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n}\n\n.field dt,\n.field dd {\n  display: inline;\n  margin: 0;\n}\n\n.field dt {\n  font-weight: var(--font-weight-semibold);\n}\n\n.field dd {\n  font-weight: var(--font-weight-regular);\n}\n\n.actions {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.copyAlertAnchor {\n  z-index: 2100;\n}\n\n.actions .actionButton {\n  flex: 1;\n  min-height: 32px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-width: 1px;\n}\n\n@media (max-width: 480px) {\n  .actions {\n    flex-direction: column-reverse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `lMbUQm`,
	"modalBody": `V4Eq6z`,
	"description": `eMn17M`,
	"fields": `HB8z1p`,
	"field": `yNxyJ9`,
	"actions": `Mpb37g`,
	"copyAlertAnchor": `oON4cX`,
	"actionButton": `t7Z883`
};
module.exports = ___CSS_LOADER_EXPORT___;
